<template>
  <section class="intro" :class="$store.state.theme">
    <h1>Salabam Solutions</h1>
    <p>Integrate travel tech into your business. Discover online travel booking solutions for your company's HR and marketing strategies.</p>
  </section>
</template>

<script>
export default {
  name: 'Intro',
};
</script>

<style scoped>
.intro {
  text-align: center;
  padding: 60px 20px;
  background: url('/assets/background-pattern.png') no-repeat center center;
  background-size: cover;
}
.intro.light {
  color: #34495e;
}
.intro.dark {
  color: #ecf0f1;
}
.intro h1 {
  font-size: 3em;
  margin-bottom: 15px;
}
.intro p {
  font-size: 1.5em;
}
</style>